import { useTranslation } from 'react-i18next';
import { usePageChrome } from '@/components/layout/page-chrome';
import { Card } from '@/components/ui/card';

/**
 * A titled empty screen for routes whose feature work lands in a later task
 * (Initiatives list, Intake wizard, Sales Cycle Timing, Reports, Administration).
 * It exists so the shell's navigation resolves to a real, titled route today
 * rather than a dead link, without pretending the feature is built.
 *
 * Both the title and the note are supplied as i18n keys (R18.9); nothing
 * user-facing is passed as literal text.
 */
export function PlaceholderPage({
  titleKey,
  noteKey,
}: {
  titleKey: string;
  noteKey: string;
}): React.JSX.Element {
  const { t } = useTranslation();
  const title = t(titleKey);
  usePageChrome({ title });
  return (
    <Card className="p-6">
      <p className="text-[13px] font-semibold text-txt">{title}</p>
      <p className="text-muted-foreground mt-1 text-[12.3px]">{t(noteKey)}</p>
    </Card>
  );
}
